import * as React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { Date, DateField, RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';

import * as T from '@modules/employees/_employeesTypes';
import { get } from 'lodash';

const enhance = compose<T.EmplyeesFormProps, T.Outter & T.EmplyeesFormProps>(
  reduxForm({
    form: 'module-employee-contracts'
  })
);

const View: React.SFC<T.Outter & T.EmplyeesFormProps> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Od</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} name="start" />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Do</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} name="end" allowFuture={true} />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Funkce</h4>
              </Col>
              <Col md={8}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  id="workPosition"
                  name="workPosition"
                  url="/metropolis/api/hr/work-positions"
                  label="Pracovní pozice"
                  filterActive={true}
                  labelFunction={o => get(o, 'name')}
                  arrowstyle={{
                    color: '#e1e0e1',
                    position: 'absolute',
                    right: 0,
                    top: 16
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EmployeesFormContractsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormContractsForm.tsx